module.exports = __webpack_public_path__ + "img/screenshot2.e4405ccf.png";